<div class="p-3 wrapper">
  <div class="title">{{ 'Transactions' | translate }}</div>
  <form [formGroup]="formGroup" class="search-form">
    <div class="row pt-2 pb-3">
      <div class="col-12 col-sm-6 col-lg-4">
        <div class="w-100 h-100 d-flex flex-column">
          <div class="w-100 d-flex">
            <div class="w-100 me-1 d-flex align-items-center form-group">
              <lib-datepicker-ngb-form-control
                ngDefaultControl
                [formControl]="$any(formGroup.controls['transactionDateBegin'])"
                [placeholder]="'From' | translate"
                [minDate]="null"
                [maxDate]="null"
                [inputClass]="'form-control datepicker-input'"
                [containerClass]="'datepicker-container icon-wrapper d-flex flex-row align-items-center mb-1'"
                [faIconClass]="'datepicker-icon ms-1'"
              ></lib-datepicker-ngb-form-control>
            </div>
            <div class="w-100 ms-1 d-flex align-items-center form-group">
              <lib-datepicker-ngb-form-control
                ngDefaultControl
                [formControl]="$any(formGroup.controls['transactionDateEnd'])"
                [placeholder]="'To' | translate"
                [minDate]="null"
                [maxDate]="null"
                [inputClass]="'form-control datepicker-input'"
                [containerClass]="'datepicker-container icon-wrapper d-flex align-items-center ms-1 mb-1'"
                [faIconClass]="'datepicker-icon ms-1'"
              ></lib-datepicker-ngb-form-control>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-4">
        <div class="mt-2 mt-xl-0 h-100 d-flex justify-content-xl-end align-items-center">
          <button type="submit" class="btn btn-primary btn-search me-md-3" (click)="onSubmit()">
            {{ 'Search' | translate }}
          </button>

          <button type="button" class="mb-1 btn btn-link reset d-none d-md-block" (click)="resetForm()">
            {{ 'Reset' | translate }}
          </button>
        </div>
      </div>
      <div class="col-12 d-md-none">
        <div class="mt-2 mt-sm-0 h-100 d-flex align-items-center">
          <button type="button" class="mb-1 btn btn-link reset" (click)="resetForm()">
            {{ 'Reset' | translate }}
          </button>
        </div>
      </div>
    </div>
  </form>
  <div class="row">
    <div class="col-12">
      <app-custom-list
        [dataProvider]="transactionListData"
        [columnsProvider]="transactionListColumnsProvider"
        (stateChanged)="onListStateChanged($event)"
        [totalCount]="totalRecords"
      ></app-custom-list>
    </div>
  </div>
</div>
